import React from 'react';
import { MdClose, MdGroup, MdLocationOn, MdInfo, MdDateRange } from 'react-icons/md';

const ViewGroupModal = ({ isOpen, onClose, group }) => {
  if (!isOpen || !group) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        width: '90%',
        maxWidth: 600,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
          paddingBottom: 16,
          borderBottom: '1px solid #e0e0e0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdGroup size={24} style={{ color: '#1976d2' }} />
            <h2 style={{ margin: 0, color: '#333', fontSize: 20 }}>Group Details</h2>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MdClose size={24} style={{ color: '#666' }} />
          </button>
        </div>

        {/* Group Information */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {/* Basic Info */}
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: 16,
            borderRadius: 8,
            border: '1px solid #e9ecef',
          }}>
            <h3 style={{ margin: '0 0 12px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <MdInfo size={20} style={{ color: '#1976d2' }} />
              Basic Information
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div>
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Group Name</label>
                <p style={{ margin: '4px 0 0 0', fontSize: 14, color: '#333' }}>{group.group_name}</p>
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Zone</label>
                <p style={{ margin: '4px 0 0 0', fontSize: 14, color: '#333' }}>
                  <span style={{
                    padding: '2px 8px',
                    backgroundColor: '#e3f2fd',
                    borderRadius: 4,
                    fontSize: 12,
                    fontWeight: 'bold',
                    color: '#1976d2',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 4
                  }}>
                    <MdLocationOn size={12} />
                    {group.zone_name}
                  </span>
                </p>
              </div>
            </div>
            <div style={{ marginTop: 12 }}>
              <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Description</label>
              <p style={{ margin: '4px 0 0 0', fontSize: 14, color: '#333' }}>
                {group.description || 'No description provided'}
              </p>
            </div>
          </div>

          {/* Status and Stats */}
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: 16,
            borderRadius: 8,
            border: '1px solid #e9ecef',
          }}>
            <h3 style={{ margin: '0 0 12px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <MdGroup size={20} style={{ color: '#1976d2' }} />
              Status & Statistics
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div>
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Status</label>
                <p style={{ margin: '4px 0 0 0', fontSize: 14 }}>
                  <span style={{
                    padding: '4px 8px',
                    borderRadius: 4,
                    fontSize: 12,
                    fontWeight: 'bold',
                    backgroundColor: group.status === 'active' ? '#e8f5e8' : '#ffebee',
                    color: group.status === 'active' ? '#2e7d32' : '#c62828'
                  }}>
                    {(group.status || 'active').charAt(0).toUpperCase() + (group.status || 'active').slice(1)}
                  </span>
                </p>
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#666', fontWeight: 'bold' }}>Members</label>
                <p style={{ margin: '4px 0 0 0', fontSize: 14, color: '#333' }}>
                  <span style={{
                    padding: '4px 8px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: 4,
                    fontSize: 12,
                    color: '#666'
                  }}>
                    {group.member_count || 0} members
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Date Information */}
 

          {/* Group Management Info */}
          <div style={{
            backgroundColor: '#e8f5e8',
            padding: 16,
            borderRadius: 8,
            border: '1px solid #c8e6c9',
          }}>
            <h3 style={{ margin: '0 0 8px 0', color: '#2e7d32', fontSize: 14, fontWeight: 'bold' }}>
              Group Management
            </h3>
            <p style={{ margin: 0, fontSize: 12, color: '#2e7d32' }}>
              This group operates within the {group.zone_name} zone. You can manage group members, 
              assign revenue officers, and monitor group activities from your regional dashboard.
            </p>
          </div>
        </div>

        {/* Close Button */}
        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: 4,
              backgroundColor: '#1976d2',
              color: 'white',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 'bold',
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewGroupModal;
